import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, UrlModule } from '@spartacus/core';
import { CarouselModule, MediaModule } from '@spartacus/storefront';

import { KnBrProductCarouselComponent } from './kn-br-product-carousel.component';
import { AtgAddToCartModule } from '../../atg/atg-add-to-cart/atg-add-to-cart.module';

@NgModule({
  declarations: [KnBrProductCarouselComponent],
  imports: [
    CommonModule,
    CarouselModule,
    MediaModule,
    RouterModule,
    UrlModule,
    AtgAddToCartModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductCarouselComponent: {
          component: () => import('./kn-br-product-carousel.component').then((c) => c.KnBrProductCarouselComponent),
        },
      },
    } as CmsConfig),
  ],
  providers: [],
})
export class KnBrProductCarouselModule {}
